import classNames from 'classnames';
var classes = {
    type: {
        h1: 'h1',
        h2: 'h2',
        h3: 'h3',
        h4: 'h4',
        h5: 'h5',
        h6: 'h6',
    },
};
var Heading = function (_a) {
    var children = _a.children, level = _a.level, type = _a.type, className = _a.className, _b = _a.center, center = _b === void 0 ? false : _b;
    var Tag = "h".concat(level);
    return (<Tag className={classNames(classes.type[type !== null && type !== void 0 ? type : Tag], center && 'text-center', className)}>
      {children}
    </Tag>);
};
export default Heading;
